export default {
  items: [
    {
      title: 'Voip',
      id: 'Voip',
      to: null,
      icon: 'icon',
      sortOrder: 10,
      expanded: true,
      children: [
        {
          title: 'Voip',
          to: { name : 'VoipIndexPage'},
          icon: 'user',
          sortOrder: 10,
        }
      ]
    }
  ]
}
